import { Component, OnInit, NgZone, Inject } from '@angular/core';
import { SearchService } from '../services/search.service';
import { query } from '@angular/animations';
import { Router, ActivatedRoute } from '@angular/router';
import * as firebase from 'firebase';
import { Roles } from '../models/Roles';
import { AuthService } from '../services/auth.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { UserprofileComponent } from '../userprofile/userprofile.component';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})

export class SearchComponent implements OnInit {
  nameSearch: string;
  searchResult = [];
  patientIdSearch: string;
  caseName: string;
  fileName: string;
  fileID: string;
  fileUploadUser: string;
  currentUser: firebase.User;

  constructor(public searchs: SearchService, public router: Router, public ng: NgZone, public route: ActivatedRoute,
    public auths: AuthService, public dialog: MatDialog, public dialogRef: MatDialogRef<SearchComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.nameSearch = '';
    this.patientIdSearch = '';
    this.caseName = '';
    this.fileName = '';
    this.fileID = '';
    this.fileUploadUser = '';
  }

  ngOnInit() {
    this.auths.user.subscribe((user) => {
      if (user) {
        this.currentUser = user;
      }
    });
    this.getAllPatients(this.data.realRole.toString(), this.data.email.toString());
    this.searchs.searchResults.subscribe((querySnapshot) => {
      this.searchResult = [];
      querySnapshot.forEach((doc) => {
        const firstName = doc.data().FirstName.charAt(0).toUpperCase() + doc.data().FirstName.slice(1);
        const lastName = doc.data().LastName = doc.data().LastName.charAt(0).toUpperCase() + doc.data().LastName.slice(1);
        const caseName = doc.data().caseName;
        const lcid = doc.data().LegalCaseId;
        const dob = doc.data().DateOfBirth;
        const item = {
          FirstName: firstName, LastName: lastName, caseName: caseName, LegalCaseId: lcid, DateOfBirth: dob,
          sharedUserFiles: doc.data().files
        };
        let result = [];
        item.sharedUserFiles.forEach((file) => {
          if (file.sharedUsers) {
            if (file.sharedUsers.includes(this.currentUser.email)) {
              result.push(item);
            }
          }
        });
        if ((result.length > 0) || this.data.realRole.toString() === Roles.superUser ||
          doc.data().uidOfCreator === this.currentUser.uid) {
          this.searchResult.push(item);
        }
      });
    });
  }

  search() {
    this.searchs.search(this.caseName);
  }

  searchRefine() {
    if (this.patientIdSearch.trim() !== '') {
      this.searchResult = this.searchResult.filter(data => data['PatientId'] === this.patientIdSearch);
    }
    if (this.nameSearch.trim() !== '') {
      this.searchResult = this.searchResult.filter(data => data['LastName'].toLowerCase() === this.nameSearch.toLowerCase());
    }
  }

  routeToProfile(caseName: string) {
    const dconfig = new MatDialogConfig();
    dconfig.width = '100vw';
    dconfig.data = {
      casename: caseName,
    }
    const dialogRef = this.dialog.open(UserprofileComponent, dconfig);
  }

  getAllPatients(realRole: string, email: string) {
    const db = firebase.firestore();

    db.collection('patients').get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        const firstName = doc.data().FirstName.charAt(0).toUpperCase() + doc.data().FirstName.slice(1);
        const lastName = doc.data().LastName = doc.data().LastName.charAt(0).toUpperCase() + doc.data().LastName.slice(1);
        const caseName = doc.data().caseName;
        const lcid = doc.data().LegalCaseId;
        const dob = doc.data().DateOfBirth;
        const item = {
          FirstName: firstName,
          LastName: lastName,
          caseName: caseName,
          LegalCaseId: lcid,
          DateOfBirth: dob,
          sharedUserFiles: doc.data().files
        };

        let result = [];
        item.sharedUserFiles.forEach((file) => {
          if (file.sharedUsers) {
            if (file.sharedUsers.includes(email)) {
              result.push(item);
            }
          }
        });

        if ((result.length > 0) || realRole === Roles.superUser || doc.data().uidOfCreator === this.currentUser.uid) {
          this.searchResult.push(item);
        }
      });
    });
  }

  goBack() {
    window.history.back();
  }
}
